<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <!--정산현황 -->
            <piaf-breadcrumb :heading="$t('menu.settlement-status')" />
            <div class="separator mb-5"></div>
        </b-colxx>
    </b-row>
    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4">
                <b-row>
                    <b-colxx xxs="12">
                        <div class="form-group has-float-label">
                            <b-input-group>
                                <template v-slot:prepend>
                                    <b-input-group-text style="padding: 5px 10px;">
                                        <b-icon icon="calendar"></b-icon>
                                    </b-input-group-text>
                                </template>
                                <vue-monthly-picker v-model="currentMonth" :clearOption="false" dateFormat="YYYY-MM" :monthLabels="['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']" selectedBackgroundColor="#c11314" alignment="center" :max="this.$moment(new Date().setMonth(new Date().getMonth() -1 ))">
                                </vue-monthly-picker>
                                <b-button variant="primary default" size="sm" class="ml-2 mr-2" @click="searchData">검색</b-button>
                                <!--                  <b-button variant="warning default" size="sm" @click="openInvoice">인보이스</b-button>-->
                            </b-input-group>
                            <span>사용월</span>
                        </div>
                    </b-colxx>
                </b-row>

                <b-row>
                    <b-colxx xxs="12">
                        <b-card class="mb-4" title="매출내역">
                            <template v-if="isLoad">
                                <b-row>

                                    <b-table-simple head-variant="light" class="vuetable" id="table-transition-example" responsive sticky-header="500px" show-empty>
                                        <b-thead head-variant="light">
                                            <b-tr>
                                                <template v-for="(field , index ) in fields">
                                                    <b-th style="text-align: center">{{ field.label }}</b-th>
                                                </template>
                                            </b-tr>
                                        </b-thead>

                                        <b-tbody>
                                            <template v-for="(store , i ) in this.storeList">
                                                <b-tr>
                                                    <b-td style="text-align:center">
                                                        {{ store.storeName }}
                                                    </b-td>
                                                    <b-td></b-td>
                                                    <b-td style="text-align:center">
                                                        {{ store.transactionAmountTotal  | currency }}
                                                    </b-td>
                                                    <b-td style="text-align:center">
                                                        {{ store.salesCommissionTotal  | currency }}
                                                    </b-td>
                                                    <b-td style="text-align:center">
                                                        {{ store.penaltyAmountTotal | currency }}
                                                    </b-td>
                                                    <b-td style="text-align:center">
                                                        {{ store.penaltyCommissionTotal | currency }}
                                                    </b-td>
                                                    <b-td style="text-align:center">
                                                        {{ store.transferredAmountTotal | currency }}
                                                    </b-td>
                                                    <b-td style="text-align:center">
                                                        <b-button :class="store.visible? 'glyph-icon iconsminds-arrow-up-3' : 'glyph-icon iconsminds-arrow-down-3'" variant="outline-primary" :pressed.sync="store.visible"></b-button>
                                                    </b-td>
                                                </b-tr>

                                                <template v-for="(settlements , i ) in store.settlements" v-if="store.visible">
                                                    <b-tr>
                                                        <b-td></b-td>
                                                        <b-td style="text-align:center">{{ settlements.completedDate.substr(0, 10) }}</b-td>
                                                        <b-td style="text-align:center">
                                                            {{ settlements.transactionAmount | currency }}
                                                        </b-td>
                                                        <b-td style="text-align:center">
                                                            {{ settlements.salesCommission | currency }}
                                                        </b-td>
                                                        <b-td style="text-align:center">
                                                            {{ settlements.penaltyAmount | currency }}
                                                        </b-td>
                                                        <b-td style="text-align:center">
                                                            {{ settlements.penaltyCommission | currency }}
                                                        </b-td>
                                                        <b-td style="text-align:center">
                                                            <span class="cls_click" @click="getDetail(store.storeCode, [settlements.salesFrom, settlements.salesTo])">
                                                                {{ settlements.transferredAmount | currency }}
                                                            </span>
                                                        </b-td>
                                                    </b-tr>
                                                </template>

                                            </template>
                                        </b-tbody>
                                        <b-tfoot>
                                            <b-tr>
                                                <b-th colspan="2" style="text-align:center;background:#f6c797 !important">합계 :</b-th>
                                                <b-th style="text-align:center;background:#f6c797 !important">{{ salePriceTotal | currency }}
                                                </b-th>
                                                <b-th style="text-align:center;background:#f6c797 !important">{{ commissionTotal | currency }}
                                                </b-th>
                                                <!-- <b-th style="text-align:center;background:#f6c797 !important">{{ netPriceTotal | currency }}
                                                </b-th> -->
                                                <b-th style="text-align:center; background:#f6c797 !important">{{ penaltyAmountTotal | currency }}</b-th>
                                                <b-th style="text-align:center; background:#f6c797 !important">{{ penaltyCommissionTotal | currency }}</b-th>
                                                <b-th style="text-align:center; background:#f6c797 !important">{{ transferredAmountTotal | currency }}</b-th>
                                                <b-th style="text-align:center; background:#f6c797 !important"></b-th>
                                                
                                            </b-tr>
                                        </b-tfoot>

                                        <!--                      <template v-slot:empty="row">-->
                                        <!--                        <h5 style="text-align: center; font-weight: lighter">검색된 매출 데이터가 없습니다.</h5>-->
                                        <!--                      </template>-->

                                    </b-table-simple>
                                </b-row>
                            </template>
                            <template v-else>
                                <div class="loading"></div>
                            </template>
                        </b-card>

                    </b-colxx>
                </b-row>

                <b-row>
                    <b-colxx xxs="12" v-show="selectFlag">
                        <b-card class="mb-4" title="세부내역">
                            <b-tabs content-class="m-4" active-nav-item-class="font-weight-bold text-danger">
                                <b-tab title="쿠폰별로 보기">
                                    <coupon-list-view ref="coupon_list" />
                                </b-tab>
                                <b-tab title="사용일별 보기">
                                    <order-list-view :useDate="true" ref="order_list" />
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </b-colxx>
                </b-row>

                <invoice ref="modal_invoice" />
            </b-card>
        </b-colxx>
    </b-row>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import api from "../../constants/api";
import {
    alignTableCenter,
    currencyFilter
} from "../../utils";
import '../../assets/css/custom/common.css'
import CouponListView from './components/CouponListView'
import OrderListView from './components/OrderListView'
import Invoice from "./components/Invoice";

const now = new Date()
export default {
    components: {
        'v-select': vSelect,
        'coupon-list-view': CouponListView,
        'order-list-view': OrderListView,
        'invoice': Invoice,
    },
    filters: {
        ...currencyFilter
    },
    data() {
        return {
            userRole: null,
            isLoad: false,
            currentMonth: this.$moment(new Date().setMonth(new Date().getMonth() - 1)),
            selectFlag: false,
            storeList: [],
            visibleRows: [],
            testflag: false,
            fields: [{
                    key: "storeName",
                    label: "매장명",
                    ...alignTableCenter
                },
                {
                    key: "date",
                    label: "입금일",
                    ...alignTableCenter
                },
                {
                    key: "salePrice",
                    label: "판매가",
                    ...alignTableCenter
                },
                {
                    key: "commission",
                    label: "수수료",
                    ...alignTableCenter
                },
                {
                    key: "penaltyAmountTotal",
                    label: "위약금",
                    ...alignTableCenter
                },
                {
                    key: "penaltyCommissionTotal",
                    label: "위약금수수료",
                    ...alignTableCenter
                },
                {
                    key: "transferredAmountTotal",
                    label: "총입금액",
                    ...alignTableCenter
                },
                {
                    key: "visible",
                    label: "",
                    ...alignTableCenter
                }
            ],
            selectedDate: null,
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName']),
        salePriceTotal() {
            return this.storeList.reduce((accum, item) => {
                return accum + (item.transactionAmountTotal != null ? Number(item.transactionAmountTotal) : 0)
            }, 0.0)
        },
        commissionTotal() {
            return this.storeList.reduce((accum, item) => {
                return accum + (item.salesCommissionTotal != null ? Number(item.salesCommissionTotal) : 0)
            }, 0.0)
        },
        netPriceTotal() {
            return this.storeList.reduce((accum, item) => {
                return accum + (item.transferredAmountTotal != null ? Number(item.transferredAmountTotal) : 0)
            }, 0.0)
        },
        penaltyAmountTotal() {
            return this.storeList.reduce((accum, item) => {
                return accum + (item.penaltyAmountTotal != null ? Number(item.penaltyAmountTotal) : 0)
            }, 0.0)
        },
        penaltyCommissionTotal() {
            return this.storeList.reduce((accum, item) => {
                return accum + (item.penaltyCommissionTotal != null ? Number(item.penaltyCommissionTotal) : 0)
            }, 0.0)
        },
        transferredAmountTotal() {
            return this.storeList.reduce((accum, item) => {
                return accum + (item.transferredAmountTotal != null ? Number(item.transferredAmountTotal) : 0)
            }, 0.0)
        },
    },
    mounted() {
        this.userRole = this.currentUser.userRole.split('_')[0]
        this.searchData()
    },
    methods: {
        searchData() {
            this.selectFlag = false
            this.isLoad = false
            this.storeList = []
            if (this.currentMonth == null) {
                alert("사용일을 설정해주세요")
                return
            }

            const params = {
                "year": Number(this.currentMonth.format('YYYY')),
                "month": Number(this.currentMonth.format('MM'))
            }

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.sales.completedSettlements)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.sales.completedSettlementsStr)
            }

            console.log(params);

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    console.log("data", res.data);
                    const vm = this

                    let stores = null
                    if (this.userRole == "BRAND") {
                        stores = res.data.data.brand.stores
                        stores.forEach(function (value) {
                            let store = {
                                storeCode: value.storeCode,
                                storeName: value.storeName,
                                transactionAmountTotal: value.transactionAmountTotal,
                                transactionAmount: value.transactionAmount,
                                transferredAmountTotal: value.transferredAmountTotal,
                                totalDeliveryAmount: value.totalDeliveryAmount,
                                salesCommissionTotal: value.salesCommissionTotal,
                                salesCommission: value.salesCommission,
                                penaltyAmountTotal: value.penaltyAmountTotal,
                                penaltyAmount: value.penaltyAmount,
                                penaltyCommissionTotal: value.penaltyCommissionTotal,
                                penaltyCommission: value.penaltyCommission,
                                transferredAmountTotal: value.transferredAmountTotal,
                                differenceAmountTotal: value.differenceAmountTotal,
                                settlements: value.settlements,
                                visible: false
                            }
                            vm.storeList.push(store)
                        })

                    } else {
                        stores = res.data.data.store
                        let store = {
                            storeCode: stores.storeCode,
                            storeName: stores.storeName,
                            transactionAmountTotal: stores.transactionAmountTotal,
                            transferredAmountTotal: stores.transferredAmountTotal,
                            salesCommissionTotal: stores.salesCommissionTotal,
                            totalDeliveryAmount: stores.totalDeliveryAmount,
                            penaltyAmountTotal: stores.penaltyAmountTotal,
                            penaltyCommissionTotal: stores.penaltyCommissionTotal,
                            transferredAmountTotal: stores.transferredAmountTotal,
                            differenceAmountTotal: stores.differenceAmountTotal,
                            settlements: stores.settlements,
                            visible: false
                        }

                        vm.storeList.push(store)

                    }

                    console.log(this.storeList);
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);

            })
            this.isLoad = true

        },

        async getDetail(storeCode, date) {
            const vm = this

            this.selectFlag = false
            let item = []

            const params = {
                salesFrom: this.$moment(date[0]).format('YYYY-MM-DD'),
                salesTo: this.$moment(date[1]).format('YYYY-MM-DD')
            }

            console.log(params);

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.sales.settlements)
                Object.assign(params, {
                    storeCode: storeCode
                })
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.sales.settlementsStr)
            }

            await this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    ;
                    const dates = res.data.data.dates

                    dates.forEach(function (v, index) {
                        v.goodsTypes.forEach(function (vv, index) {
                            item.push(vv)
                        })
                    })

                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

            this.$refs.coupon_list.init(null, null, item)
            this.$refs.order_list.init(null, null, item)
            this.selectFlag = true

        },
        openInvoice() {
            this.$refs.modal_invoice.open(this.currentMonth.toDate())
        }
    },
    watch: {}
}
</script>
